import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../service/auth.service';
import { base_host, environment, my_port, my_protocol } from 'src/environments/environment';


@Component({
  selector: 'app-admin-company-details',
  templateUrl: './admin-company-details.component.html',
  styleUrls: ['./admin-company-details.component.css']
})
export class AdminCompanyDetailsComponent implements OnInit {

  companies = [];
  company;
  errMessage = "";
  successMessage = "";
  routeID:string = this.route.snapshot.params.id;
  businessID: string = this.route.snapshot.params.businessID;
  authToken = localStorage.getItem('auth');
  users = [];
  pathUrl;
  order;
  isAverageCert = false;
  isNPSCert = false;
  subGroups = [];
  day_price = 0;
  price = 0;
  days = 0;
  isLoading = false;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) {

     }

  ngOnInit(): void {
    this.getBusinessDetails();
    this.getUsers()
    this.calculateBilling();
    this.fetchSubGroups();
    console.log(this.routeID, this.businessID);
  }

  fetchSubGroups() {
    this.http.get(environment.ADMIN_SUBGROUPS + '/' +this.routeID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.subGroups = res.message;



          console.log(this.subGroups);

        }
        else {

        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  getBusinessDetails() {

    this.http.get(environment.ADMIN_BUSINESS_DETAILS + '/' +this.routeID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.company = res.message[0];


          console.log(this.company);

        }
        else {

        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  calculateBilling() {

  }

  getUsers() {

    this.http.get(environment.ADMIN_COMPANY_EMPLOYERS + '/' +this.routeID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.users = res.message;

          console.log(this.users);

        }
        else {

        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  removeCompany(){
    this.http.delete(environment.ADMIN_BUSINESS_DETAILS + '/' +this.routeID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.router.navigate(['/admin/companies']);
        }
        else {

        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  updatePrice(){
    var camp_value = parseInt((<HTMLInputElement>document.getElementById('campaign')).value);

    if(this.days == 0)

    if(camp_value && camp_value > 0){
   
        var feed_ad_price = this.day_price;
        this.price =  camp_value * this.day_price;
      


    }
    else{
      if(camp_value < 0){
        alert("Kampanjan arvon tulee olla positiivinen");
      }
    }
  }

  updateDays(){
    var camp_value = parseInt((<HTMLInputElement>document.getElementById('days-camp')).value);

    if(camp_value && camp_value > 0){
   
      this.day_price = camp_value;
      


    }
    else{
      if(camp_value < 0){
        alert("Kampanjan arvon tulee olla positiivinen");
      }
    }
  }

  increaseCampaign(){
    

    var camp_value = parseInt((<HTMLInputElement>document.getElementById('campaign')).value);

    if((<HTMLInputElement>document.getElementById('cost_center')).value){
      var cost_center = (<HTMLInputElement>document.getElementById('cost_center')).value;
    }
    else{
      var cost_center = "";
    }


    
    var req = {
      days: camp_value,
      day_price: this.day_price,
      businessID: this.routeID,
      cost_center: cost_center,
    }

    this.http.put(environment.ADMIN_COMPANY_PINNING + '/'+this.routeID, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          
          document.getElementById('create-campaign-btn').click();
          this.getBusinessDetails();

        }
        else {
          alert(
            'Poistaminen ei onnistunut. Ole hyvä ja yritä uudelleen'
          )
        }
        
      })

  }

}
